import { Injectable } from '@angular/core';
import {
  Http,
  XHRBackend,
  XHRConnection,
  RequestOptions,
  Request,
  ResponseContentType,
  RequestOptionsArgs,
  Response,
  Headers
} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { TokenKey } from './tokenKey';
import { HttpConst } from '../resources/http/http.const';

@Injectable()
export class AuthenticationService {

  urlRefresToken = `${HttpConst.apiUrl}/token/Refrescar/`;

  constructor(private http: Http) { }

  refreshToken(): Observable<boolean> {

    const tokenlocal: TokenKey = JSON.parse(localStorage.getItem(HttpConst.LOCAL_STORAGE_KEY_TOKEN));

    return this.http.get(this.urlRefresToken + tokenlocal.refreshToken)
    .map(response => {
      localStorage.removeItem(HttpConst.LOCAL_STORAGE_KEY_TOKEN);
      if(response.json()!=null){
        if(JSON.stringify(response.json())!=null){
          localStorage.setItem(HttpConst.LOCAL_STORAGE_KEY_TOKEN, JSON.stringify(response.json()));
        }
      }
        return true;
      });
    /*.toPromise()
    .then(this.recuperarDatos).catch(this.controlarError);*/
      /*.map(response => {
        localStorage.removeItem(HttpConst.LOCAL_STORAGE_KEY_TOKEN);
        localStorage.setItem(HttpConst.LOCAL_STORAGE_KEY_TOKEN, JSON.stringify(response.json()));
        return true;
      });*/
  }

  recuperarDatos(response: any) {
    let resultado: any;
    const retorno = response;
    resultado = retorno;
    return resultado;
  }

  controlarError(error: Response | any) {
   // console.log('Aqui error');
    console.error(error.message || error);
    return Promise.reject(error.message || error);
  }

}
